import React from 'react';
import { Outlet } from 'react-router-dom';
import { 
  Box, 
  Container,
  useColorModeValue
} from '@chakra-ui/react';
import Navbar from './Navbar';
import Footer from './Footer';

function Layout() {
  const bgColor = useColorModeValue('gray.50', 'gray.800');

  return (
    <Box bg={bgColor} minHeight="100vh" display="flex" flexDirection="column">
      <Navbar />
      <Container maxW="container.xl" flexGrow={1} py={6}>
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
}

export default Layout;